<section [formGroup]="employment_info" fxLayout="row" fxLayout.xs="column"
         fxLayoutGap="20px">

  <bb-number number="2"></bb-number>

  <div fxLayout="column" fxLayoutGap="20px" fxFlex="100">
    <h2 class="request-txt">EMPLOYMENT INFORMATION</h2>
    <div class="subtle">Choose One</div>

    <div fxLayout="row" fxLayoutGap="100px" fxLayout.xs="column" fxLayoutGap.xs="8px">

      <div fxLayout="column" fxLayoutGap="8px" fxFlex="35">
        <mat-radio-group formControlName="employment_type" fxLayout="row"
                         fxLayoutGap="20px" fxLayoutAlign="start center">
          <mat-radio-button color="primary" value="land">Land</mat-radio-button>
          <mat-radio-button color="primary" value="sea">Sea</mat-radio-button>
        </mat-radio-group>

        <mat-form-field *ngIf="employment_info.get('employment_type').value === employment_type.land">
          <mat-select placeholder="Destination country" required formControlName="destined_country">
            <ng-container *ngFor="let country of country.list|async">
              <mat-option [value]="country.alpha2" *ngIf="country.name !=='Philippines'">
                {{country.name}}
              </mat-option>
            </ng-container>
          </mat-select>
          <mat-error *ngIf="employment_info.get('destined_country').hasError('required')">Required.</mat-error>
        </mat-form-field>

        <mat-form-field>
          <bb-job-title-field formControlName="job_title"
                              jobTitleLinkControlName="job_title_link"
                              jobCategoryControlName="job_category"
                              (setJobTitlePk)="employment_info.get('job_title_link').setValue($event)"
                              (setJobCategoryPk)="employment_info.get('job_category').setValue($event)"
                              placeholder="Job title" required></bb-job-title-field>
          <mat-error *ngIf="employment_info.get('job_title').hasError('required')">Required.</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-select placeholder="Job category" required formControlName="job_category">
            <ng-container *ngFor="let category of jobCategory.list|async">
              <mat-option [value]="category.id" *ngIf="category.type === employment_info.get('employment_type').value">
                {{category.category}}
              </mat-option>
            </ng-container>
          </mat-select>
          <mat-error *ngIf="employment_info.get('job_category').hasError('required')">Required.</mat-error>
        </mat-form-field>

        <mat-form-field>
          <input matInput placeholder="Monthly salary" required formControlName="monthly_salary" type="number">
          <mat-error *ngIf="employment_info.get('monthly_salary').hasError('required')">Required.</mat-error>
          <mat-error *ngIf="employment_info.get('monthly_salary').hasError('min')">
            Minimum salary is <b>₱ 20,000</b>.
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="35">
        <bb-land-based *ngIf="employment_info.value.employment_type==employment_type.land"></bb-land-based>
        <bb-seaman *ngIf="employment_info.value.employment_type==employment_type.sea"></bb-seaman>
      </div>
    </div>
  </div>
</section>


